import { IUserRole } from '~/types';

import { AllocationRole } from '../model/types';

const hasGlobalUserRoleInClinic = (
  roles: AllocationRole[] | undefined,
  clinicId: string | number,
): boolean =>
  !!roles
    ?.filter(role => role.clinic.id === Number(clinicId))
    .find(role => role.name === IUserRole.GlobalUser);

export default hasGlobalUserRoleInClinic;
